import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import './ProductTabItem.scss';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import Icon from '@/components/Icon/Icon';

interface ProductTabItemProps {
    active: boolean;
    onClick: (label: string) => void;
    label: string;
    id: string;
}

const ProductTabItem: FC<ProductTabItemProps> = ({ active, label, id, onClick }) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    const onClickHandler = useCallback(() => {
        onClick(label);
    }, [label, onClick]);

    return (
        <div
            className={classNames(
                'product-tab-item tw-w-[233px] lg:tw-w-full lg:tw-max-w-[351px]',
                { active },
            )}
            onClick={onClickHandler}
        >
            <h4 {...inspectorProps({ fieldId: 'title' })}>{label}</h4>
            <Icon type="angleRight" className="icon" />
        </div>
    );
};

export default ProductTabItem;
